import React from "react";
import { cn } from "../../lib/utils";

/**
 * Underline style sub-tabs for secondary navigation on mobile.
 */
export default function MobileUnderlineTabBar({
  tabs,
  value,
  onChange,
  className = "",
  testId = "mobile-underline-tabs",
}) {
  if (!tabs?.length) return null;

  return (
    <div
      className={cn("lg:hidden flex items-stretch border-b border-border/70 bg-card/60 -mx-1", className)}
      role="tablist"
      data-testid={testId}
    >
      {tabs.map((tab) => {
        const active = value === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.id)}
            className={cn(
              "relative flex-1 min-h-10 px-1.5 py-2.5 text-[11px] transition-colors duration-150 touch-manipulation",
              active ? "font-semibold text-primary" : "font-medium text-muted-foreground/80 active:text-foreground/70",
            )}
            data-testid={`${testId}-${tab.id}`}
          >
            <span className="flex items-center justify-center gap-1 truncate">
              <span className="truncate">{tab.label}</span>
              {tab.badge > 0 && (
                <span
                  className={cn(
                    "shrink-0 min-w-[1rem] h-4 px-1 rounded-full text-[9px] font-semibold leading-none inline-flex items-center justify-center",
                    active ? "bg-bansal-sage/15 text-primary" : "bg-muted text-muted-foreground",
                  )}
                >
                  {tab.badge > 99 ? "99+" : tab.badge}
                </span>
              )}
            </span>
            {active && (
              <span className="absolute bottom-0 left-2 right-2 h-[2px] rounded-full bg-bansal-sage" aria-hidden />
            )}
          </button>
        );
      })}
    </div>
  );
}
